import React, { useEffect, useRef, useState } from 'react'
import IconBtn from '../../../common/IconBtn';
import { useDispatch, useSelector } from 'react-redux';
import {FiUpload } from "react-icons/fi"
import { updateDisplayPicture } from '../../../../services/operations/settingsAPI';

const ChangeProfilePicture = () => {
    
    const {user} = useSelector((state) => state.profile);
    const {token} = useSelector((state) => state.auth);
    const dispatch = useDispatch();

    const [previewSource, setPreviewSource] = useState(null);
    const [loading, setLoading] = useState(false);
    const [imageFile, setImageFile] = useState(null);

    const fileInputRef = useRef();

    const handleClick = ()=>{
        fileInputRef.current.click();
    }

    const handleFileChange =(e)=>{
        const file = e.target.files[0];
        if(file){
            setImageFile(file);
            // previewFile(file);
        }
    }

    const previewFile = (file)=>{
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () =>{
            setPreviewSource(reader.result);
        }
    }

    useEffect(() =>{
        if(imageFile){
            previewFile(imageFile);
        }
    },[imageFile]);

    const handleFileUpload = ()=>{
        try {
            setLoading(true);
            const formData = new FormData();
            formData.append("displayPicture", imageFile);
            dispatch(updateDisplayPicture(token, formData));
            setLoading(false);
        } catch (error) {
            console.log(error);
        }
    }

  return (
    <div className='flex items-center justify-between rounded-md border-[1px] border-richblack-700 bg-richblack-800 p-8 px-12 text-richblack-5'>
        <div className="flex items-center gap-x-4">
            <img src={previewSource || user?.image} alt={`profile-${user?.firstName}`} className="aspect-square w-[78px] rounded-full object-cover"/>
            <div className="space-y-2">
                <p>Change Profile Picture</p>
                <div className="flex flex-row gap-3">
                    <input type="file" className='hidden' accept="image/png, image/gif, image/jpeg" ref={fileInputRef} onChange={handleFileChange}/>
                    <button className="cursor-pointer rounded-md bg-richblack-700 py-2 px-5 font-semibold text-richblack-50" disabled={loading} onClick={handleClick}>
                        Select
                    </button>
                    <IconBtn text={loading ? "Uploading..." : "Upload"} onClick={handleFileUpload}>
                        {
                            !loading && (<FiUpload className="text-lg text-richblack-900"/>)
                        }
                    </IconBtn>
                </div>

            </div>
        </div>
    </div>
  )
}

export default ChangeProfilePicture
